/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnUpLeftIcon16Light = forwardRef('ArrowDUturnUpLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.168.126a.5.5 0 1 1 .664.748L3.315 4H8.5a5.5 5.5 0 0 1 0 11h-4a.5.5 0 0 1 0-1h4a4.5 4.5 0 1 0 0-9H3.315l3.517 3.126a.5.5 0 1 1-.664.748L2.508 5.62a1.5 1.5 0 0 1 0-2.242L6.169.126Z" })));
});
